import Vue from 'vue';
import service from './base.service'
import {AxiosPromise} from 'axios';
import {AppResponse} from '@/share/response';
import {ProfileModel, UserModel} from "@/share";

export class UserService extends Vue {
  private RESOURCE = '/front/users';

  public getProfile(): AxiosPromise<AppResponse<UserModel>> {
    return service.get<AppResponse<UserModel>>(`${this.RESOURCE}/get-profile`);
  }

  public updateProfile(payload: any): AxiosPromise<AppResponse<ProfileModel>> {
    return service.post<AppResponse<UserModel>>(`${this.RESOURCE}/update-profile`, payload);
  }
}
